import React from 'react';
import {
  CookbookSingleSelectSearchBase,
  CookbookSingleSelectSearchWrapperProps,
} from 'src/components/CookbookSingleSelectSearchBase/CookbookSingleSelectSearchBase';
import { useServerSelectSearch } from 'src/components/CookbookServerSelectSearchWrapper/useServerSelectSearch';

export type CookbookServerSelectSearchWrapperProps = Omit<
  CookbookSingleSelectSearchWrapperProps,
  'onSearchChange' | 'onCollapse' | 'onSelect'
> & {
  fetchOptions: (searchQuery?: string) => Promise<void>;
};

export function CookbookServerSelectSearchWrapper({
  fetchOptions,
  options,
  ...props
}: CookbookServerSelectSearchWrapperProps): JSX.Element {
  const { displayedOptions, isInitialLoading, onSearchHandle, restoreOptions } =
    useServerSelectSearch(fetchOptions, options);

  return (
    <CookbookSingleSelectSearchBase
      {...props}
      options={displayedOptions}
      onSearchChange={(value: string): void => onSearchHandle(value)}
      onCollapse={restoreOptions}
      onSelect={restoreOptions}
      placeholder={isInitialLoading ? 'loading...' : props.placeholder}
    />
  );
}
